import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    this.resetModal()
    document.getElementById("export-modal").classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.resetModal()
    const modal = document.getElementById("export-modal")
    if (modal) modal.classList.add("hidden")
    document.body.style.overflow = ""
  }

  backdropClose(e) {
    if (e.target === e.currentTarget) this.close()
  }

  resetModal() {
    const modal = document.getElementById("export-modal")
    if (!modal) return
    const submitBtn = modal.querySelector('button[type="submit"]')
    const cancelBtn = modal.querySelector('[data-cancel-btn]')
    const exportSection = modal.querySelector('[data-export-modal-target="exportSection"]')
    const statusFrame = modal.querySelector('turbo-frame#export_status_result')

    if (submitBtn) submitBtn.classList.remove("hidden")
    if (cancelBtn) cancelBtn.classList.remove("hidden")
    if (exportSection) exportSection.classList.add("hidden")
    if (statusFrame) statusFrame.innerHTML = '<div class="text-center text-sm text-slate-500 py-2">正在提交导出请求...</div>'
  }

  async submit(e) {
    e.preventDefault()
    const modal = document.getElementById("export-modal")
    const form = modal.querySelector('form')
    if (!form) return

    const formData = new FormData(form)
    const submitBtn = modal.querySelector('button[type="submit"]')
    const cancelBtn = modal.querySelector('[data-cancel-btn]')
    const exportSection = modal.querySelector('[data-export-modal-target="exportSection"]')

    if (submitBtn) submitBtn.classList.add("hidden")
    if (cancelBtn) cancelBtn.classList.add("hidden")
    if (exportSection) exportSection.classList.remove("hidden")

    const resp = await fetch(`${form.action}`, {
      method: "POST",
      body: formData,
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": this.csrfToken()
      }
    })

    if (!resp.ok) {
      alert("导出请求失败，请重试")
      this.resetModal()
      return
    }

    Turbo.renderStreamMessage(await resp.text())
  }

  csrfToken() {
    return document.querySelector("meta[name=csrf-token]")?.content || ""
  }
}